import * as React from 'react'

import { cn } from '#/shared/lib/utils'
import { Button } from '#/shared/ui/button'

interface EditorEmptyProps {
  description: string
  actionLabel: string
  actionIcon?: React.ReactNode
  onAction?: () => void
  actionDisabled?: boolean
  className?: string
}

function EditorEmpty({
  description,
  actionLabel,
  actionIcon = (
    <span aria-hidden className="text-base leading-none">
      +
    </span>
  ),
  onAction,
  actionDisabled,
  className,
}: EditorEmptyProps) {
  return (
    <div
      className={cn(
        'flex h-35 w-full flex-col items-center justify-center gap-3.75 rounded-md',
        className,
      )}
    >
      <p className="w-81 text-center text-sm text-gray-500">{description}</p>
      <Button
        size="xs"
        pressEffect
        disabled={actionDisabled}
        onClick={onAction}
      >
        {actionIcon}
        {actionLabel}
      </Button>
    </div>
  )
}

export { EditorEmpty }
export type { EditorEmptyProps }
